import { Dialog, DialogTitle, DialogContent, Button } from "@mui/material";
import { toMoney } from "../../util/Utils";
import { Box, TextField } from "@mui/material";

export default function DetailPopUp(props) {
  return (
    <Dialog
      PaperProps={{
        elevation: 1,
      }}
      fullWidth
      open={props.detailShow.show}
      onClose={() => props.setDetailShow({ ...props.detailShow, show: false })}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle color="secondary" id="alert-dialog-title">
        جزئیات گزارش فروش
      </DialogTitle>
      <DialogContent>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn="span 6">
            <TextField
              fullWidth
              id="outlined-basic"
              label="تعداد سفارش"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.productDetail.orderCount
                  ? toMoney(props.productDetail.orderCount)
                  : "0"
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn="span 6">
            <TextField
              fullWidth
              id="outlined-basic"
              label="جمع کل"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.productDetail.totalOrginalCost
                  ? toMoney(props.productDetail.totalOrginalCost)
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn="span 6">
            <TextField
              fullWidth
              id="outlined-basic"
              label="درصد تخفیف مستقیم"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.productDetail.totalDiscountPercent
                  ? toMoney(props.productDetail.totalDiscountPercent)
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn="span 6">
            <TextField
              fullWidth
              id="outlined-basic"
              label="تخفیف مستقیم"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.productDetail.totalDiscount
                  ? toMoney(props.productDetail.totalDiscount)
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn="span 6">
            <TextField
              fullWidth
              id="outlined-basic"
              label="تخفیف اعتباری"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.productDetail.totalCredit
                  ? toMoney(props.productDetail.totalCredit)
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn="span 6">
            <TextField
              fullWidth
              id="outlined-basic"
              label="مبلغ پرداخت شده"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.productDetail.totalCost
                  ? toMoney(props.productDetail.totalCost)
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            gridColumn="span 12"
          >
            <Button color="secondary" sx={{ mr: 2 }} variant="contained">
              چاپ
            </Button>
            <Button
              onClick={() =>
                props.setDetailShow({ ...props.detailShow, show: false })
              }
              color="secondary"
              variant="outlined"
            >
              بستن
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
